import React, { useCallback } from 'react';
import axios from 'axios';
import config from '../../../config';
import DataGridShell from './DataGridShell';

const money = (p) => p?.value != null ? Number(p.value).toFixed(2) : '0.00';

const columns = [
    { field: 'tenant_store_name', headerName: 'Tenant Name', width: 150 },
    { field: 'tenant_group_name', headerName: 'Group Name', width: 200 },
    { field: 'tenant_code', headerName: 'Tenant Code', width: 150 },
    { field: 'tenant_unit_code', headerName: 'Unit Code', width: 150 },
    { field: 'tenant_status', headerName: 'Status', width: 130 },
    { field: 'property_name', headerName: 'Property', width: 150 },
    { field: 'subcategory_name', headerName: 'Subcategory', width: 200 },
    { field: 'floor', headerName: 'Floor', width: 100 },
    { field: 'transaction_date', headerName: 'Date', width: 130 },
    { field: 'transaction_count', headerName: 'Tx Count', width: 130, type: 'number', cellClass: 'ag-right-aligned-cell' },
    { field: 'net_sales', headerName: 'Net Sales', width: 150, type: 'number', cellClass: 'ag-right-aligned-cell', valueFormatter: money },
    { field: 'gross_amount', headerName: 'Gross Amount', width: 160, type: 'number', cellClass: 'ag-right-aligned-cell', valueFormatter: money },
    { field: 'tax_amount', headerName: 'Tax Amount', width: 130, type: 'number', cellClass: 'ag-right-aligned-cell', valueFormatter: money },
    { field: 'discount_amount', headerName: 'Discount', width: 130, type: 'number', cellClass: 'ag-right-aligned-cell', valueFormatter: money },
    { field: 'return_amount', headerName: 'Returns', width: 130, type: 'number', cellClass: 'ag-right-aligned-cell', valueFormatter: money }
];

const kpiAccumulators = [
    { field: 'net_sales', label: 'Σ Net Sales', money: true },
    { field: 'transaction_count', label: 'Σ Transactions', money: false }
];

const DataGridView = () => {
    const preFetch = useCallback(async () => {
        const concessionaire_id = localStorage.getItem('concessionaireId');
        const token = localStorage.getItem('sessiontoken');
        try {
            const res = await axios.post(
                `${config.hostname}/concessionairedeliverypartner/getdeliverypartner`,
                { concessionaire_id },
                { headers: { Authorization: `${token}` } }
            );
            const partners = (res.data || [])
                .map(item => item?.delivery_partner_id?.delivery_partner_name)
                .filter(Boolean)
                .filter(n => n !== 'Dine In');
            return partners.flatMap(p => {
                const slug = p.toLowerCase().replace(/\s+/g, '_');
                return [
                    { field: `${slug}_count`, headerName: `${p} Count`, width: 150, type: 'number', cellClass: 'ag-right-aligned-cell' },
                    { field: `${slug}_sales`, headerName: `${p} Sales`, width: 150, type: 'number', cellClass: 'ag-right-aligned-cell', valueFormatter: money }
                ];
            });
        } catch (e) {
            console.error('[DataGridView] preFetch delivery partners failed:', e?.message);
            return [];
        }
    }, []);

    return (
        <DataGridShell
            mode="daily"
            endpoint="/datagrid/getdatagrid"
            exportEndpoint="/datagridexport/export-csv"
            columns={columns}
            kpiAccumulators={kpiAccumulators}
            preFetch={preFetch}
        />
    );
};

export default DataGridView;
